// API مربوط به لیست قولنامه‌های کاربر

import { httpClient } from "./httpClient";

// لیست قولنامه‌های قبلی کاربر (با صفحه‌بندی و فیلتر وضعیت اختیاری)
export function getMyContracts({ page = 1, limit = 10, status } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });
  if (status) params.set("status", status);

  return httpClient.get(`/contract/mine?${params.toString()}`);
}

// دریافت جزئیات یک قولنامه با شناسه
export function getContractById(contractId) {
  return httpClient.get(`/contract/${contractId}`);
}
